import { type FC } from 'react';
import { useIntl } from 'react-intl';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';

import KiosImage from 'modules/quick-search/components/KiosImage';
import type { QsChannel } from 'modules/quick-search/types';

interface Props {
  channels: QsChannel[];
  selectedId?: number;
  onSelect: (channel: QsChannel) => void;
}

/** Hàng chip Kênh phân phối (KPP): ảnh + tên + "(N) PLHH". */
const ChannelChips: FC<Props> = ({ channels, selectedId, onSelect }) => {
  const { formatMessage } = useIntl();

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
      {channels.map((ch) => {
        const selected = ch.id === selectedId;
        return (
          <ButtonBase
            key={ch.id}
            onClick={() => onSelect(ch)}
            sx={{
              display: 'flex',
              alignItems: 'stretch',
              borderRadius: 2,
              overflow: 'hidden',
              bgcolor: 'background.paper',
              boxShadow: 1,
              border: 2,
              borderColor: selected ? 'primary.main' : 'transparent',
              minWidth: 210,
              textAlign: 'left',
            }}
          >
            <KiosImage
              src={ch.image}
              alt={ch.name}
              fallbackIconSize={24}
              sx={{ width: 56, height: 56, objectFit: 'cover', bgcolor: 'action.hover', flexShrink: 0 }}
            />
            <Box sx={{ px: 1.5, py: 0.75, flexGrow: 1 }}>
              <Typography
                sx={{ fontWeight: 700, color: selected ? 'primary.main' : 'text.primary', lineHeight: 1.2 }}
              >
                {ch.name}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {formatMessage(
                  { id: 'quickSearch.classificationCount' },
                  { count: ch.classificationCount }
                )}
              </Typography>
            </Box>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default ChannelChips;
